// @flow

export const initialState = {
  // Add your initial Redux state here
}
